/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {checkRestrictionsForTransfer} from '../api'

export const useMutationCheckRestrictionsForTransfer = createReactQueryMutationHook('checkRestrictionsForTransfer', checkRestrictionsForTransfer)
